<template>
  <!--
    作者：kmdshop
    时间：2023-01-01
    描述：插件中心-股东分红
  -->
  <div>
    
    <!--商品设置-->
    <groupaward v-if="activeName == 'groupaward'"></groupaward>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import groupaward from './groupaward/index';

export default {
  components: {
    groupaward
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'groupaward',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'groupaward',
          value: '设置',
          path:'/plus/groupaward/groupaward/index'
        },
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.authFilter();

    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'groupaward'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'groupaward', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/groupaward/index.vue